export default "__VITE_ASSET__DFZPiKNh__"